import { HskEntry } from "./types";

export const HSK_CHAR_PACK = "hsk-char";

export const getCardId = (card: Pick<HskEntry, "charSimp" | "order">) => {
  if (!card.charSimp || card.charSimp === "?") {
    return `${HSK_CHAR_PACK}:unknown:${card.order}`;
  }
  return `${HSK_CHAR_PACK}:${card.charSimp}`;
};
